/**
 * <s-sticky-header> — wraps the middle header row.
 *
 * When the row is sticky (data-sticky), it publishes its live height as
 * `--sticky-header-height` on <html>, so other sticky elements (e.g. the product
 * details column) can sit below it instead of sliding underneath. Height changes
 * (font loading, resize, wrapping) are tracked with a ResizeObserver.
 * When not sticky, the variable is 0px.
 */
class SStickyHeader extends HTMLElement {
  /** @type {ResizeObserver | null} */
  #observer = null;

  connectedCallback() {
    const root = document.documentElement;
    if (!this.hasAttribute('data-sticky')) {
      root.style.setProperty('--sticky-header-height', '0px');
      return;
    }
    const publish = () => root.style.setProperty('--sticky-header-height', `${Math.ceil(this.getBoundingClientRect().height)}px`);
    publish();
    this.#observer = new ResizeObserver(publish);
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
    document.documentElement.style.removeProperty('--sticky-header-height');
  }
}

if (!customElements.get('s-sticky-header')) {
  customElements.define('s-sticky-header', SStickyHeader);
}
